<template>
  <span v-if="modelValue" class="text-error">{{ modelValue }}</span>
  <span v-else>-</span>
</template>
<script setup lang="ts">
interface Props {
  modelValue: string | null;
}

defineProps<Props>();
</script>
